import { of } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import { catchError, switchMap } from 'rxjs/operators';

import { getConfig, KuxConfig, KuXConfig } from '../config';

interface TranslationFromPoEditorArgs {
  proxy?: string;
  language: string;
  projectId: string;
  poEditorToken: string;
  exportProjectPoeditorAPI: string;
}

export const downloadTranslation = (downloadUrl: string, proxy?: string) => {
  // console.log(downloadUrl, 'downloadUrl');
  if (!downloadUrl) {
    throw new Error("Can't get download url");
  }

  const url = proxy ? `${proxy}/${downloadUrl}` : downloadUrl;
  return ajax.getJSON(url).pipe(
    catchError((error) => {
      return of({});
    }),
  );
};

export const exportProjectFromPOEditor = (args: TranslationFromPoEditorArgs) => {
  const { language, projectId, proxy, poEditorToken, exportProjectPoeditorAPI } = args;

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  const body = `api_token=${poEditorToken}&id=${projectId}&language=${language}&type=key_value_json`;

  const url = proxy ? `${proxy}/${exportProjectPoeditorAPI}` : exportProjectPoeditorAPI;
  const config: KuxConfig = getConfig(KuXConfig)('');

  return ajax({
    method: 'post',
    body,
    headers,
    url,
    timeout: config.requestTimeout,
  }).pipe(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    switchMap(({ response }: any) => {
      return downloadTranslation(response.result.url, proxy);
    }),
    catchError((error) => {
      return of({});
    }),
  );
};
